import { DailySummaryFormValues } from './dailySummaryModels';

export const filterNonEmptyTimeBlocks = (timeBlocks: DailySummaryFormValues['timeBlocks']) => {
    return Object.keys(timeBlocks).filter((timeBlockId) => (
        Object.values((window as any)._.omit(timeBlocks[timeBlockId], 'customData')).some(value => !!value) ||
        Object.values(timeBlocks[timeBlockId].customData || {}).some(value => !!value && !!value.length)
    ));
};